import { getLogger } from "@goodgamestudios/logger";
import {TOOLBOX_LOGGER} from "../../../index";

export class LogListManager {

    private static logger = getLogger(TOOLBOX_LOGGER);

    constructor(){

    }

    public static logTrace(logText: string): void {
        this.logger.warn("LogListManager.logTrace - is not implemented");
    }

    public static activate(): void{
        this.logger.warn("LogListManager.activate - is not implemented");
    }

    public static copyToClipboard(timeIntervalInSecond: number = 600, entrysAmount: number = -1, header: string = ""): void{
        this.logger.warn("LogListManager.copyToClipboard - is not implemented");
    }
}